module.exports = __webpack_public_path__ + "img/icon-zoom-in.3e904b87.svg";